import { render } from "./CameraAgente.vue?vue&type=template&id=2105502f"
import script from "./CameraAgente.vue?vue&type=script&lang=js"
export * from "./CameraAgente.vue?vue&type=script&lang=js"

import "./CameraAgente.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__